import { BreadcrumbItem } from '@src/api/common/BreadcrumbTypes';
import { PageTitle } from '@src/api/common/PageTitleType';

const Breadcrumbs: Array<BreadcrumbItem> = [
  {
    title: 'Demo',
    isLink: false,
  },
  {
    title: 'Device Migration',
    isLink: false,
  },
];

const Title: PageTitle = {
  title: 'Device Migration',
};

export { Breadcrumbs, Title };